module.exports = __webpack_public_path__ + "static/media/162.87396dc3.jpg";